var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.09,
    height: 11.09,
    viewBox: "0 0 11.09 11.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_238575",
    "data-name": "Path 238575",
    d: "M4.7,1.924a1.54,1.54,0,1,0,1.54,1.54A1.54,1.54,0,0,0,4.7,1.924ZM2.232,3.464A2.464,2.464,0,1,1,4.7,5.929,2.464,2.464,0,0,1,2.232,3.464Zm5.7-2A.462.462,0,0,1,8.393,1a2.464,2.464,0,1,1,0,4.929.462.462,0,0,1,0-.924,1.54,1.54,0,1,0,0-3.08A.462.462,0,0,1,7.931,1.462ZM1,10.626A3.466,3.466,0,0,1,4.466,7.161h.462a3.466,3.466,0,0,1,3.466,3.466A1.463,1.463,0,0,1,6.93,12.09H2.463A1.463,1.463,0,0,1,1,10.626ZM4.466,8.085a2.541,2.541,0,0,0-2.541,2.541.539.539,0,0,0,.539.539H6.93a.539.539,0,0,0,.539-.539A2.541,2.541,0,0,0,4.928,8.085Zm3.62-.462a.462.462,0,0,1,.462-.462h.077a3.466,3.466,0,0,1,3.466,3.466,1.463,1.463,0,0,1-1.463,1.463h-1a.462.462,0,0,1,0-.924h1a.539.539,0,0,0,.539-.539A2.541,2.541,0,0,0,8.624,8.085H8.547A.462.462,0,0,1,8.085,7.623Z",
    transform: "translate(-1 -1)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.4dac5a7411c150c9c6d4debf3f7f3305.svg";
export { ForwardRef as ReactComponent };